import "./ImagePopup.scss";

import { Component, h, render } from "preact";
import { useCallback, useEffect, useRef } from "preact/hooks";

import Hammer from "hammerjs";
import classNames from "classnames";

function ImagePopup({
  images = [],
  activeImage = 0,
  isOpen = false,
  onClose,
  onNext,
  onPrev,
}) {
  const onKeyPress = useCallback(
    (e) => {
      if (isOpen && e.keyCode === 27) {
        onClose();
      } else if (isOpen && e.keyCode === 39) {
        onNext();
      } else if (isOpen && e.keyCode === 37) {
        onPrev();
      }
    },
    [onClose, isOpen]
  );

  const onSwipeLeft = useCallback(() => {
    onPrev();
  }, [onPrev]);

  const onSwipeRight = useCallback(() => {
    onNext();
  }, [onNext]);

  const popupRef = useRef();

  useEffect(() => {
    if (!popupRef.current) return;

    const hammer = new Hammer(popupRef.current);

    hammer.on("swipe", function (e) {
      if (e.direction === Hammer.DIRECTION_LEFT) {
        onPrev();
      } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        onNext();
      }
    });

    return () => {
      hammer.stop(true);
      hammer.destroy();
    };
  }, [popupRef, onPrev, onNext]);

  useEffect(() => {
    window.addEventListener("keydown", onKeyPress);

    return () => window.removeEventListener("keydown", onKeyPress);
  }, [onKeyPress]);

  return (
    <div
      ref={popupRef}
      className={classNames("CCImagePopup", isOpen && "CCImagePopup_open")}
    >
      <button className="CCImagePopup__close t-text" onClick={onClose}>
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 14L14 1M1 1.1406L13.5903 13.7309"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
      <button className="CCImagePopup__prev" onClick={onPrev}>
        <svg
          width="9"
          height="16"
          viewBox="0 0 9 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM2 7H1L1 9H2L2 7Z"
            fill="white"
          />
        </svg>
      </button>
      <button className="CCImagePopup__next" onClick={onNext}>
        <svg
          width="9"
          height="16"
          viewBox="0 0 9 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289L2.34315 0.928932C1.95262 0.538408 1.31946 0.538408 0.928932 0.928932C0.538408 1.31946 0.538408 1.95262 0.928932 2.34315L6.58579 8L0.928932 13.6569C0.538408 14.0474 0.538408 14.6805 0.928932 15.0711C1.31946 15.4616 1.95262 15.4616 2.34315 15.0711L8.70711 8.70711ZM7 9H8V7H7V9Z"
            fill="white"
          />
        </svg>
      </button>
      <div className="CCImagePopup__activeImage">
        <img src={images[activeImage]?.url} />
      </div>
    </div>
  );
}

export default ImagePopup;
